import { gql } from "@apollo/client";

export const GET_PROMO_DEDUCTION_APPLY_SUMMARY = gql`
  query GetPromoDeductionApplySummary($params: GetPromoDeductionApplySummaryInput!) {
    getPromoDeductionApplySummary(params: $params) {
      totalDeductionsClaimed
      totalDeductionsAmount
      count
      page
      limit
      data {
        deduction {
          id
          checkNumber
          invoiceNumber
          invoiceDate
          amount
          stage {
            stageId
            stageKey
            stageName
            isCurrent
          }
          status {
            statusId
            statusKey
            statusName
            isCurrent
          }
          analystUser {
            userId
            fullName
            avatar
            isDeleted
          }
        }
        matchSummary {
          confidenceScore
          matchStatus
          isBestMatch
          displayMatchStatus
        }
        application {
          appliedId
          appliedAt
          applicationSource
        }
      }
    }
  }
`;
